module.exports = __webpack_public_path__ + "static/media/boat-img-14.d4d84ce9.jpg";